import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

export interface ProcessImagesRequest {
  width: number;
  height: number;
  backgroundColor: string;
  mode: string;
  imageStyle?: 'none' | 'frosted' | 'matte' | 'pastel' | 'sunset';
  zipFile?: File;
  imageFiles?: File[];
  originalFileName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ImageProcessorService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  processImages(request: ProcessImagesRequest): Observable<Blob> {
    const formData = new FormData();
    
    // Si hay un ZIP, enviarlo
    if (request.zipFile) {
      formData.append('zipFile', request.zipFile);
    }
    
    // Si hay imágenes individuales, enviarlas
    if (request.imageFiles && request.imageFiles.length > 0) {
      request.imageFiles.forEach((file, index) => {
        formData.append('imageFiles', file);
      });
    }
    
    formData.append('width', request.width.toString());
    formData.append('height', request.height.toString());
    formData.append('backgroundColor', request.backgroundColor);
    formData.append('mode', request.mode);
    
    // Enviar estilo de imagen si está especificado
    if (request.imageStyle) {
      formData.append('imageStyle', request.imageStyle);
    }
    
    // Enviar nombre original del archivo para el nombre de descarga
    if (request.originalFileName) {
      formData.append('originalFileName', request.originalFileName);
    }

    return this.http.post(`${this.apiUrl}/api/process-images`, formData, {
      responseType: 'blob',
      reportProgress: true
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  checkHealth(): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/health`).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}


